import React, { useEffect } from "react";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import { WereHouseRoute } from "../../were-house.routes";
import { columns } from "./components/columns";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useDispatch } from "react-redux";
import {
  getInventoryStatusBannedItemsListingAction,
  getInventoryStatusListingAction,
} from "src/app-redux/warehouse/actions/wareHouseActions";
import { loader as loading } from "src/app-redux/warehouse/wareHouseSlice";
import { useAppSelector } from "src/app-redux/hooks";
import { useFormik } from "formik";
import { FormControlLabel, Grid, Switch } from "@material-ui/core";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";

const rows: any = [
  { typeOfCargo: "item1", totalWeight: 342 },
  { typeOfCargo: "item2", totalWeight: 839 },
  { typeOfCargo: "item3", totalWeight: 563 },
  { typeOfCargo: "item4", totalWeight: 9374 },
];

export function ListStatus() {
  const dispatch = useDispatch();
  const loader: any = useAppSelector(loading);
  const moduleName = WereHouseRoute.title;
  const pageHeading = WereHouseRoute.subRoutes ? WereHouseRoute.subRoutes[2].title : "Page Title";
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [gridRecord, setGridRecord] = React.useState<GridRowModel[]>([]);

  const formik = useFormik({
    initialValues: {
      bannedItems: false,
    },
    onSubmit: () => {
      // alert(JSON.stringify(values, null, 2));
    },
  });
  const addSerialNumber = async (rows: any) => {
    const transformedData = await rows?.map((row: any, index: number) => ({
      ...row,
      id: index,
      sNo: index + 1,
    }));
    return transformedData;
  };

  const getInventoryStatus = async () => {
    const date = {
      daily: null,
      monthly: null,
      yearly: null,
    };
    const results: any = await dispatch(getInventoryStatusListingAction(date));
    const rows = await results?.payload?.inventryStatusLists;
    const transformedRows: any = await addSerialNumber(rows);
    setGridRecord(transformedRows);
  };
  const getInventoryStatusBannedItems = async () => {
    const date = {
      daily: null,
      monthly: null,
      yearly: null,
    };
    const results: any = await dispatch(getInventoryStatusBannedItemsListingAction(date));
    const rows = await results?.payload?.inventryBannedItemLists;
    const transformedRows: any = await addSerialNumber(rows);
    setGridRecord(transformedRows);
  };

  useEffect(() => {
    formik.values.bannedItems ? getInventoryStatusBannedItems() : getInventoryStatus();
  }, [formik.values.bannedItems]);

  useEffect(() => {
    if (rows.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "totalWeight"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                const value = `${row.original.totalWeight ? row.original.totalWeight : "0"}`;
                const weightUnit = ` ${
                  row.original.weightUnit
                    ? row.original.weightUnit == "Cubic meter"
                      ? "m³"
                      : row.original.weightUnit
                    : "KG"
                }`;
                return `${value} ${weightUnit} `;
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, []);

  return (
    <>
      <CommonDataGridPage
        module={moduleName}
        heading={pageHeading}
        GridDataComp={
          <CommonMaterialGrid
            rows={gridRecord}
            columns={displayColumns}
            defaultPerPageRecord={15}
            loader={loader}
            height={450}
          />
        }
      >
        <>
          <Grid spacing={2} container direction="row">
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={Boolean(formik.values.bannedItems)}
                    onChange={formik.handleChange}
                    name="bannedItems"
                    color="primary"
                  />
                }
                label="Seized goods"
              />
            </Grid>
          </Grid>
        </>
      </CommonDataGridPage>
    </>
  );
}
